// The running app's store, for code outside React that needs auth state
// (fetchAuthWrapper for file downloads).
let storeRegistry: { getState: () => unknown } | null = null;

export const registerStore = (store: { getState: () => unknown }): void => {
    storeRegistry = store;
};

export const getStore = (): { getState: () => unknown } => {
    if (!storeRegistry) {
        throw new Error(
            'Store not registered. Call registerStore(store) in your store.ts before using fetchAuthWrapper.'
        );
    }
    return storeRegistry;
};
